<template>
  <ModalDialog
    ref="dialog"
    :title="dialogTitle"
    :showSubmit="false"
    :icon="dialogIcon"
    :scrollable="true"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <FormGroup v-if="!loading">
      <ActionDropMenu class="float-right" v-if="canResendCommunication">
        <DropdownMenuItem @click="resendCommunicationLog" icon="fa-paper-plane">Resend</DropdownMenuItem>
      </ActionDropMenu>
      <div class="communication-header border-bottom pb-2">
        <p class="p-0 m-0 text-muted"> From: 
          <LinkUser v-if="communicationLog.user" :id="communicationLog.user.id" :name="communicationLog.user.name" />
          <span v-if="!communicationLog.user">System</span>
        </p>
        <p class="p-0 m-0 text-muted">To: {{recipientList}}</p>
        <p class="p-0 m-0 text-muted" v-if="ccList">CC: {{ccList}}</p>
        <p class="p-0 m-0 text-muted">{{communicationLog.createdAt | formatDateCustom('dddd, MMMM Do YYYY [at] h:mm a')}}</p>
        <h4 class="pt-2">{{communicationLog.messageSubject}}</h4>
      </div>
      <div class="communication-body border-bottom py-3">
        <div v-html="communicationLog.messageContent" />
      </div>
      <div class="mt-4" v-if="communicationLog.userFiles && communicationLog.userFiles.length > 0">
        <h5>Attachments</h5>
        <FileAttachment v-for="file in communicationLog.userFiles" :key="file.id" :file="file" :newTab="true" />
      </div>
    </FormGroup>
  </ModalDialog>
</template>

<style scoped>

</style>


<script>
import _ from 'lodash'
import moment from 'moment'
import form from '@/mixins/form'
import Utils from '@/utils/utils'

import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { CommunicationMethodTypes, CommunicationMethodTypeLookup } from '@/store/types'

export default {
  name: 'CommunicationLogDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    communicationLogId: Number
  },
  data() {
    return {
      communicationLog: { },
      loading: false,
      loadingError: '',
    }
  },
  created() {
  },
  mounted() {
    this.requestCommunicationData()
  },
  computed: {
    recipientList() {
      if(!this.communicationLog || !this.communicationLog.recipientList)
        return ''
      return this.communicationLog.recipientList.join(', ')
    },
    ccList() {
      if(!this.communicationLog || !this.communicationLog.ccList)
        return ''
      return this.communicationLog.ccList.join(', ')
    },
    canResendCommunication() {
      if(!this.userHasCreatePermission(this.PermissionTypes.CommunicationPermissionTypes.resendCommunication))
        return false

      // Can only resend emails
      return this.communicationLog.methodType == CommunicationMethodTypes.email
    },
    dialogTitle() {
      if(this.communicationLog.methodType)
        return `View ` + Utils.getLookupName(CommunicationMethodTypeLookup, this.communicationLog.methodType)
      
      return 'View Communication'
    },
    dialogIcon() {
      if(this.communicationLog.methodType == CommunicationMethodTypes.sms)
        return 'fa-sms'
      
      return 'fa-envelope-open-text'
    }
  },
  methods: {
    show(options = {}) {
      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {      
    },

    requestCommunicationData() {
      this.communicationLog = {}
      this.loadingError = ''

      this.$apiService.communicationService.getCommunicationLog(this.communicationLogId)
      .then(response => {
        this.communicationLog = response.data
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
      })
    },
    resendCommunicationLog() {
      this.loadingError = ''
      let commDlg = this

      let methodTypeName = Utils.getLookupName(CommunicationMethodTypeLookup, this.communicationLog.methodType)
      this.confirmMessage(`Resend ${methodTypeName}?`, `Resend the original communication to the contact again?`)
      .then(confirmed => {
        if(confirmed) {

          this.hide()
          this.modalClosed(false)
          
          this.$nextTick(() => {
            commDlg.displayProcessingDialog({
              title: 'Resending communication',
              message: '',
              icon: 'fa-paper-plane',
              onBeforeOpen: (instance) => {
                commDlg.$api.post(`/communication/communicationlogs/${this.communicationLogId}/resend`)
                .then(() => {
                  commDlg.successToast(`${methodTypeName} Resent`)
                })
                .catch(err => {
                  commDlg.displayNetworkError(err, 'Error resending communication')
                })
                .finally(() => {
                  instance.hide()
                })
              }
            }, {
              mountBody: true
            })
          })
        }
      })
    }
  }
}
</script>